export const formatNumber = (num = 0) => {
  if (num == null || isNaN(num)) return "0";

  if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  }

  if (num >= 1_000) {
    return `${(num / 1_000).toFixed(1).replace(/\.0$/, "")}k`;
  }

  return String(num);
};

export const roundTo2 = (num = 0) =>
  Math.round((Number(num) + Number.EPSILON) * 100) / 100;

export const toIntPercent = (num = 0) =>
  Number.isFinite(Number(num)) ? `${Math.round(Number(num))}%` : "0%";

export const formatDuration = (ms = 0) => {
  const value = Number(ms);
  if (!Number.isFinite(value) || value <= 0) return "0 s";

  if (value >= 60_000) {
    return `${roundTo2(value / 60_000)} min`;
  }

  if (value >= 1_000) {
    return `${roundTo2(value / 1_000)} s`;
  }

  return `${roundTo2(value)} s`;
};

export const formatTimestamp = (timestamp) => {
  if (!timestamp) return "-";

  const date = new Date(timestamp);

  const pad = (n) => String(n).padStart(2, "0");

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}`;
};


